import { IVideoStudiosState } from './videoStudiosContext';
import { VideoStudiosActionTypes, TVideoStudiosAction } from './videoStudiosActions';

export const videoStudiosReducer = (state: IVideoStudiosState, action: TVideoStudiosAction): IVideoStudiosState => {
	switch (action.type) {
		case VideoStudiosActionTypes.SET_VIDEO_STUDIOS:
			return {
				...state,
				videoStudios: action.payload.videoStudios,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideoStudiosActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case VideoStudiosActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				currentPage: 1,
			};
		case VideoStudiosActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case VideoStudiosActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case VideoStudiosActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case VideoStudiosActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideoStudiosActionTypes.SET_ID_FOR_EDIT:
			return {
				...state,
				IDForEdit: action.payload.IDForEdit,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideoStudiosActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideoStudiosActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		case VideoStudiosActionTypes.REFETCH_STUDIOS:
			return {
				...state,
				needRefetchStudios: action.payload.needRefetchStudios,
			};
		default:
			return state;
	}
};
